// extracted by mini-css-extract-plugin
export default {"scoreGradeContainer":"AkPt8R8_vQfS2btebK17","scoreGrade":"ClZ1b7xKzwPRfblSDwkd","label":"bi4jmP9gofHZdmzeUYwH","bar":"GuJ1ynN6S2QNNrrNTaox","fill":"bQe71dUFPqxWbd9QzpEE"};